import { createBrowserRouter } from "react-router-dom";

import SidebarLayout from "../layout/SideBarLayout";
import ConstructionPage from "../pages/page-bases/UnderConstruction";
import { UsersMainPage } from "../pages/users";
import { AddUsersPage } from "../pages/users/AddUser";
import { AssetsMainPage } from "../pages/assets";

import MaintenanceMainPage from "../pages/maintenance";
import RolesMainPage from "../pages/roles";
import ChangePasswordPage from "../pages/change-password";
import SettingsMainPage from "../pages/settings/SettingsMain";
import AuthenticationPage from "../pages/authentication/AuthenticationPage";

import { NewAssetDistributionPage } from "../pages/asset-distribution/NewAssetDistributionPage";

import AssetCategoriesMainPage from "../pages/asset-categories";
import AssetTagsMainPage from "../pages/asset-tags";
import UserCategories from "../pages/user-categories";
import ProgramsMainPage from "../pages/programs";
import DistrictsMainPage from "../pages/districts";
import FacilitiesMainPage from "../pages/facilities";
import RegionsMainPage from "../pages/regions";
import DivisionsMainPage from "../pages/divisions";
import { AssetMaintenanceSchedule } from "../pages/maintenance/AssetMaintenanceSchedule";
import DonorsMainPage from "../pages/donors";
import BatchsMainPage from "../pages/batches";

import AssetDispatchLogsPage, {
  DispatchDetailsPage,
  NewDispatchPage,
} from "../pages/distribution-dispatch";
import { AddAssetPage } from "../pages/assets/AddAssetPage";
import { UpdateBatchDistributionPage } from "../pages/asset-distribution/UpdateBatchDistributionPage";
import { UpdateAssetPage } from "../pages/assets/UpdateAssetPage";
import { InBoundDistributionDetailPage } from "../pages/asset-distribution/InBoundDistributionDetailPage";
import AvailableDistributionForAssignementPage from "../pages/asset-assignment/AvailableDistributionForAssignementPage";
import { AssignAssetToUser } from "../pages/asset-assignment/AssignAssetToUser";
import appRoutePath from "../config/path";
import InBoundDistributionPage from "../pages/asset-distribution/InBoundDistributionPage";
import OutBoundDistributionPage from "../pages/asset-distribution/OutBoundDistributionPage";
import { OutBoundDistributionDetailPage } from "../pages/asset-distribution/OutBoundDistributionDetailPage";
import OutBondAssetAssignmentHistoryPage from "../pages/asset-assignment/OutBondAssetAssignmentHistoryPage";
import InBoundAssetAssignmentPage from "../pages/asset-assignment/InBoundAssetAssignmentPage";
import AssetsInMyPossessionPage from "../pages/asset-assignment/AssetsInMyPossessionPage";
import { InBoundDistributionActionPage } from "../pages/asset-distribution/InBoundDistributionActionPage";
import AssetReportForm from "../pages/asset-report/AssetReportForm";
import AssetReportHistory from "../pages/asset-report/AssetReportHistory";
import { RoleBaseRouteGuard } from "../common-ui/RoleBaseRouteGuard";
import { systemUser } from "../config/constants/system-users";
import UnauthorizedAccessPage from "../common-ui/UnauthorizedAccessPage";
import { EditUserPage } from "../pages/users/EditUserPage";
import AssignmentRejectionsLogsPage from "../pages/rejections/asset-assignments/AssignmentRejectionsLogs";
import { AssignmentRejectionDetailPage } from "../pages/rejections/asset-assignments/AssignmentRejectionDetailPage";
import DistributionRejectionsLogsPage from "../pages/rejections/distribution/DistributionRejectionsLogs";
import { DistributionRejectionDetailPage } from "../pages/rejections/distribution/DistributionRejectionDetailPage";
import NotFoundPage from "../pages/NotFoundPage";
import { UpdateAssetMaintenanceSchedule } from "../pages/maintenance/UpdateAssetMaintenance";
import { DashboardRedirect } from "../common-ui/DashboardRedirect";
import UpdateAssetReportForm from "../pages/asset-report/UpdateAssetReportForm";
import { AssetReportDetailPage } from "../pages/asset-report/AssetReportDetailPage";

const RootRouter = createBrowserRouter(
  [
    // {
    //   path: '/',
    //   element: <AuthenticationPage />
    // },

    { path: "*", element: <NotFoundPage /> },

    {
      path: appRoutePath.AUTH_PAGE,
      children: [
        {
          path: "",
          element: <AuthenticationPage pageState="login" />,
          index: true,
        },
        {
          path: appRoutePath.AUTH_ACCOUNT_VERIFICATION_PAGE,
          element: <AuthenticationPage pageState="verify-account" />,
        },
        {
          path: appRoutePath.AUTH_CREATE_PASSWORD_PAGE,
          element: <AuthenticationPage pageState="create-password" />,
        },
        {
          path: appRoutePath.AUTH_FORGOT_PASSWORD_PAGE,
          element: <AuthenticationPage pageState="forgot-password" />,
        },
        {
          path: appRoutePath.AUTH_RESET_PASSWORD_PAGE,
          element: <AuthenticationPage pageState="reset-password" />,
        },
      ],
    },
    {
      path: appRoutePath.UnAUTHORIZED_ACCESS_PAGE,
      element: <UnauthorizedAccessPage />,
    },
    {
      path: "/",
      element: <SidebarLayout />,
      children: [
        { path: "", element: <DashboardRedirect />, index: true },
        { path: "/reports", element: <ConstructionPage /> },
        { path: "/settings", element: <SettingsMainPage /> },

        // ASSET REGISTRY
        {
          path: appRoutePath.ASSET_REGISTRY_HISTORY_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_MANAGER,
                systemUser.IT_ADMIN,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
              ]}
            >
              <AssetsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ADD_ASSET_REGISTRY_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_MANAGER, systemUser.IT_ADMIN]}
            >
              <AddAssetPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: `${appRoutePath.EDIT_ASSET_REGISTRY_PAGE}`,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_MANAGER, systemUser.IT_ADMIN]}
            >
              <UpdateAssetPage />
            </RoleBaseRouteGuard>
          ),
        },
        // ASSET_REGISTRY_DETAIL_PAGE

        // USER MANAGEMENT
        {
          path: appRoutePath.USERS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_MANAGER, systemUser.IT_ADMIN]}
            >
              <UsersMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ADD_USERS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_MANAGER, systemUser.IT_ADMIN]}
            >
              <AddUsersPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.EDIT_USERS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_MANAGER, systemUser.IT_ADMIN]}
            >
              <EditUserPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.USERS_ROLES_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[systemUser.SUPER_ADMIN]}>
              <RolesMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        // USER_CHANGE_PASSWORD_PAGE
        {
          path: appRoutePath.USER_CHANGE_PASSWORD_PAGE,
          element: <ChangePasswordPage />,
        },

        // ASSET DISTRIBUTIONS
        {
          path: appRoutePath.ADD_ASSET_DISTRIBUTION_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <NewAssetDistributionPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_EDIT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <UpdateBatchDistributionPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_DETAILS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <InBoundDistributionDetailPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.REJECTED_INBOUND_ASSET_DISTRIBUTIONS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <DistributionRejectionsLogsPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.REJECTED_INBOUND_ASSET_DISTRIBUTIONS_DETAIL_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <DistributionRejectionDetailPage />
            </RoleBaseRouteGuard>
          ),
        },

        {
          path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <InBoundDistributionPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <OutBoundDistributionPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.OUTBOUND_ASSET_DISTRIBUTIONS_DETAIL_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <OutBoundDistributionDetailPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_ACTION_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <InBoundDistributionActionPage />
            </RoleBaseRouteGuard>
          ),
        },

        // TODO
        // OUTGOING_ASSET_DISTRIBUTIONS_EDIT_PAGE

        // ASSET DISPATCH
        {
          path: appRoutePath.ASSET_DISPATCH_HISTORY_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <AssetDispatchLogsPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ADD_ASSET_DISPATCH_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <NewDispatchPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ASSET_DISPATCH_DETAIL_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <DispatchDetailsPage />
            </RoleBaseRouteGuard>
          ),
        },

        // TODO
        // UPDATE_ASSET_DISPATCH_PAGE

        // ASSET ASSIGNMENT
        // TODO
        // EDIT_ASSET_ASSIGNMENT_PAGE,
        // ASSET_ASSIGNMENT_DETAIL_PAGE,

        // ASSET ASSIGNMENT
        {
          path: appRoutePath.INBOUND_ASSET_ASSIGNMENT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <InBoundAssetAssignmentPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.OUTBOUND_ASSET_ASSIGNMENT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <OutBondAssetAssignmentHistoryPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ASSET_DISTRIBUTION_READY_FOR_ASSIGNMENT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <AvailableDistributionForAssignementPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ADD_NEW_ASSET_ASSIGNMENT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.STORE_ADMIN, systemUser.STORE_MANAGER]}
            >
              <AssignAssetToUser />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.REJECTED_INBOUND_ASSET_ASSIGNEMENT_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.IT_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <AssignmentRejectionsLogsPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.REJECTED_INBOUND_ASSET_ASSIGNEMENT_DETAILS_PAGE,
          element: <AssignmentRejectionDetailPage />,
        },

        {
          path: appRoutePath.ASSET_IN_MY_POSSESSION_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <AssetsInMyPossessionPage />
            </RoleBaseRouteGuard>
          ),
        },

        // ASSET REPORT
        {
          path: appRoutePath.ASSET_REPORT_FORM,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.SUPER_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <AssetReportForm />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ASSET_REPORT_HISTORY,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.SUPER_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <AssetReportHistory />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.EDIT_ASSET_REPORT_FORM,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.SUPER_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <UpdateAssetReportForm />
            </RoleBaseRouteGuard>
          ),
        },

        {
          path: appRoutePath.ASSET_REPORT_DETAIL_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.SUPER_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
                systemUser.STAFF,
              ]}
            >
              <AssetReportDetailPage />
            </RoleBaseRouteGuard>
          ),
        },

        // maintenance
        {
          path: appRoutePath.ASSET_MAINTENANCE_HISTORY_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_ADMIN, systemUser.IT_MANAGER]}
            >
              <MaintenanceMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.ADD_ASSET_MAINTENANCE_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_ADMIN, systemUser.IT_MANAGER]}
            >
              <AssetMaintenanceSchedule />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: `${appRoutePath.EDIT_ASSET_MAINTENANCE_PAGE}`,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_MANAGER,
                systemUser.SUPER_ADMIN,
                systemUser.IT_ADMIN,
              ]}
            >
              <UpdateAssetMaintenanceSchedule />
            </RoleBaseRouteGuard>
          ),
        },
        //TODO
        // EDIT_ASSET_MAINTENANCE_PAGE,
        // ASSET_MAINTENANCE_DETAIL_PAGE

        // SETTINGS MANAGEMENT
        {
          path: appRoutePath.MANAGE_DIVISIONS_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[]}>
              <DivisionsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_PROGRAMMES_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[]}>
              <ProgramsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_FACILITIES_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[]}>
              <FacilitiesMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_REGIONS_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[]}>
              <RegionsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_DISTRICTS_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[]}>
              <DistrictsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_BATCHES_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[
                systemUser.IT_ADMIN,
                systemUser.IT_MANAGER,
                systemUser.STORE_ADMIN,
                systemUser.STORE_MANAGER,
              ]}
            >
              <BatchsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_ASSET_CATEGORIES_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[systemUser.IT_ADMIN]}>
              <AssetCategoriesMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_ASSET_TAGS_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[systemUser.IT_ADMIN]}>
              <AssetTagsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_USER_CATEGORIES_PAGE,
          element: (
            <RoleBaseRouteGuard roles={[systemUser.IT_ADMIN]}>
              <UserCategories />
            </RoleBaseRouteGuard>
          ),
        },
        {
          path: appRoutePath.MANAGE_DONORS_PAGE,
          element: (
            <RoleBaseRouteGuard
              roles={[systemUser.IT_ADMIN, systemUser.IT_MANAGER]}
            >
              <DonorsMainPage />
            </RoleBaseRouteGuard>
          ),
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);

export default RootRouter;
